const PRODUCT_CLASS_TYPES = [
  "HPPreconfigBasket",
  "MemberBusiness",
  "MemberGoldStar",
  "Tires",
  "DeliveryScheduling"
];
const PROGRAM_TYPES_PRICE = [
  "standard",
  "locationControlledInventory",
  "siteControlledInventory",
  "sameDayDelivery",
  "national",
  "2DayDelivery"
];
const PROGRAM_TYPES_PRICE_WAREHOUSE = [
  "InWarehouse",
  "UseWarehouseInventory",
  "LTLPickUp",
  "3rdPartyDelivery"
];
const TRAVEL_DESTINATION = "travelDestination";
const INVALID_LOCATIONS = ["9847-wcs", "9894-wcs"];
export {
  INVALID_LOCATIONS,
  PRODUCT_CLASS_TYPES,
  PROGRAM_TYPES_PRICE,
  PROGRAM_TYPES_PRICE_WAREHOUSE,
  TRAVEL_DESTINATION
};
